(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('LicencesDetailController', LicencesDetailController);

    LicencesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Licences', 'TabDomains'];

    function LicencesDetailController($scope, $rootScope, $stateParams, entity, Licences, TabDomains) {
        var vm = this;
        vm.licences = entity;
        
        var unsubscribe = $rootScope.$on('jotApp:licencesUpdate', function(event, result) {
            vm.licences = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
